import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { InlineSearchCommands } from '../enums';

export class InlineSearchSuggestionClickEvent implements IEvent {
	public static readonly EventType = InlineSearchCommands.INLINE_SEARCH_SUGGESTION_CLICK_EVENT;
	public readonly timestamp = new Date();
	public readonly eventType = InlineSearchSuggestionClickEvent.EventType;
	public readonly suggestionText: string;

	constructor(suggestionText: string) {
		this.suggestionText = suggestionText;
	}

	public static is(event: IEvent): event is InlineSearchSuggestionClickEvent {
		return event.eventType === InlineSearchSuggestionClickEvent.EventType as string;
	}
}